<template>
    <section v-if="hasAttachments" class="tp-section">
        <header class="tp-section-head">
            <i class="fal fa-paperclip tp-section-ic"></i>
            <h3 class="tp-section-title">Pièces jointes</h3>
            <span class="tp-section-count">{{ post.medias.length }}</span>
        </header>

        <div class="tp-section-body">
            <template v-for="answer in uploadAnswers">
                <component
                    :key="answer.id"
                    :medias="post.medias"
                    :is="answer.name"
                    :value="answer"
                    :post="post"
                />
            </template>
        </div>
    </section>
</template>

<script>
import PreviewFileUploadAttribute from './Attribute/PreviewFileUploadAttribute'

export default {
    name: 'PostPreviewAttachments',
    props: ['post'],
    components: {
        'file-upload': PreviewFileUploadAttribute
    },
    computed: {
        uploadAnswers() {
            const answers = (this.post && this.post.answers) || []
            return answers.filter((a) => a.name === 'file-upload')
        },
        hasAttachments() {
            return (
                this.post &&
                Array.isArray(this.post.medias) &&
                this.post.medias.length > 0 &&
                this.uploadAnswers.length > 0
            )
        }
    }
}
</script>

<style scoped>
.tp-section {
    background: var(--v2-surface-0, #fff);
    border: 1px solid var(--v2-border, #e2e8f0);
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    overflow: hidden;
}

.tp-section-head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid var(--v2-border-subtle, #f1f5f9);
    background: var(--v2-surface-1, #f8fafc);
}

.tp-section-ic {
    color: var(--v2-primary, #0891b2);
    font-size: 0.9rem;
}

.tp-section-title {
    margin: 0;
    font-size: 0.8125rem;
    font-weight: 600;
    color: var(--v2-text-1, #0f172a);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.tp-section-count {
    margin-left: auto;
    min-width: 22px;
    height: 22px;
    padding: 0 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: var(--v2-primary-soft, rgba(8, 145, 178, 0.08));
    color: var(--v2-primary, #0891b2);
    font-size: 0.7rem;
    font-weight: 700;
}

.tp-section-body {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.tp-section-body >>> h6 {
    font-size: 0.7rem !important;
    font-weight: 600 !important;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--v2-text-3, #64748b) !important;
    margin: 0 0 6px !important;
}
</style>
